import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { useInView } from "react-intersection-observer";

// css
import * as styles from "./MemberJourney.module.css";

const MemberJourneyComponent = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <section className={styles.memberJourneyWrapper}>
      <div
        className={`container scroll_animate ${inView && "inview"}`}
        ref={ref}
      >
        <div className="row">
          <div className="col-12">
            <div className={styles.headerSection}>
              <h1 className={styles.mainTitle}>Member journey</h1>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 col-12">
            <div className={styles.journeyColumn}>
              <div className={styles.journeyItem}>
                <div className={styles.iconWrapper}>
                  <StaticImage
                    src="../../../images/icons/seam_icn.png"
                    alt="Seamless Enrollment"
                    placeholder="blurred"
                    quality={90}
                    className={styles.icon}
                  />
                </div>
                <div className={styles.contentWrapper}>
                  <h3 className={styles.itemTitle}>Seamless Enrollment</h3>
                  <p className={styles.itemDescription}>
                    Enroll through our website or partner organisations and
                    connect with your dedicated metabolic health coach for
                    personalised guidance.
                  </p>
                </div>
              </div>
              <div className={styles.journeyItem}>
                <div className={styles.iconWrapper}>
                  <StaticImage
                    src="../../../images/icons/transform_icn.png"
                    alt="Transform"
                    placeholder="blurred"
                    quality={90}
                    className={styles.icon}
                  />
                </div>
                <div className={styles.contentWrapper}>
                  <h3 className={styles.itemTitle}>Transform Your Health</h3>
                  <p className={styles.itemDescription}>
                    See improvements like healthy weight loss, reduced
                    medications and a more balanced lifestyle as your metabolic
                    health steadily improves.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-12">
            <div className={styles.journeyColumn}>
              <div className={styles.journeyItem}>
                <div className={styles.iconWrapper}>
                  <StaticImage
                    src="../../../images/icons/pers_icn.png"
                    alt="Seamless Enrollment"
                    placeholder="blurred"
                    quality={90}
                    className={styles.icon}
                  />
                </div>
                <div className={styles.contentWrapper}>
                  <h3 className={styles.itemTitle}>
                    Personalized Consultation
                  </h3>
                  <p className={styles.itemDescription}>
                    Consult with your Twin Health doctor, review your blood
                    report and discuss medical history to personalise your
                    metabolic care plan.
                  </p>
                </div>
              </div>
              <div className={styles.journeyItem}>
                <div className={styles.iconWrapper}>
                  <StaticImage
                    src="../../../images/icons/support_icn.png"
                    alt="Transform"
                    placeholder="blurred"
                    quality={90}
                    className={styles.icon}
                  />
                </div>
                <div className={styles.contentWrapper}>
                  <h3 className={styles.itemTitle}>Real Time Supportt</h3>
                  <p className={styles.itemDescription}>
                    Receive continuous insights and guidance on nutrition,
                    activity and stress through the app along with expert
                    support from your care team.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-12">
            <div className={styles.journeyColumn}>
              <div className={styles.journeyItem}>
                <div className={styles.iconWrapper}>
                  <StaticImage
                    src="../../../images/icons/sensor_icn.png"
                    alt="Seamless Enrollment"
                    placeholder="blurred"
                    quality={90}
                    className={styles.icon}
                  />
                </div>
                <div className={styles.contentWrapper}>
                  <h3 className={styles.itemTitle}>Sensor Setup</h3>
                  <p className={styles.itemDescription}>
                    Use compatible smart devices such as CGMs and trackers to
                    monitor real-time metabolic data for continuous lifestyle
                    insights.
                  </p>
                </div>
              </div>
              <div className={styles.journeyItem}>
                <div className={styles.iconWrapper}>
                  <StaticImage
                    src="../../../images/icons/digital_icn.png"
                    alt="Transform"
                    placeholder="blurred"
                    quality={90}
                    className={styles.icon}
                  />
                </div>
                <div className={styles.contentWrapper}>
                  <h3 className={styles.itemTitle}>
                    Build Your AI Digital Twin
                  </h3>
                  <p className={styles.itemDescription}>
                    Build a dynamic virtual model of your metabolism inside the
                    app to create a personalised lifestyle plan tailored for
                    long-term metabolic improvement.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MemberJourneyComponent;
